export function circlePath(cx, cy, r) {
  return `M ${cx - r} ${cy} a ${r} ${r} 0 1 0 ${2 * r} 0 a ${r} ${r} 0 1 0 ${-2 * r} 0`;
}

export function ellipsePath(cx, cy, rx, ry) {
  return `M ${cx - rx} ${cy} a ${rx} ${ry} 0 1 0 ${2 * rx} 0 a ${rx} ${ry} 0 1 0 ${-2 * rx} 0`;
}

export function starPath(cx, cy, r) {
  const pts = [];
  for (let i = 0; i < 10; i++) {
    const ang = (Math.PI / 5) * i - Math.PI / 2;
    const rad = i % 2 ? r * 0.45 : r;
    pts.push(`${(cx + rad * Math.cos(ang)).toFixed(1)},${(cy + rad * Math.sin(ang)).toFixed(1)}`);
  }
  return `M${pts.join("L")}Z`;
}

export function heartPath(cx, cy, s) {
  return `M ${cx} ${cy + s * 0.62} C ${cx - s * 1.15} ${cy - s * 0.28} ${cx - s * 0.58} ${cy - s * 0.95} ${cx} ${cy - s * 0.32} C ${cx + s * 0.58} ${cy - s * 0.95} ${cx + s * 1.15} ${cy - s * 0.28} ${cx} ${cy + s * 0.62} Z`;
}

export function groundPath(y = 448) {
  return `M 0 ${y} Q 100 ${y - 20} 200 ${y - 4} Q 300 ${y + 10} 400 ${y - 12} L 400 500 L 0 500 Z`;
}

export const INK = "#241531";
